import { gql } from "@apollo/client";
import { AddressInfoFragment } from "graphql/Address/fragments";
import { OrderInfoFragment } from "graphql/Order/fragments";

export const JobInfoFragment = gql`
  fragment JobInfo on Job {
    _id
    job_UID
    job_type
    job_address {
      ...AddressInfo
    }
    job_date
    job_time
    job_status
    job_vehicle_type
    job_created_at
    job_last_edited_at
    job_orders {
      ...OrderInfo
    }
    job_client {
      _id
      client_address {
        ...AddressInfo
      }
    }
  }
  ${OrderInfoFragment}
  ${AddressInfoFragment}
`;

export const DeliverySlotsFragment = gql`
  fragment DeliverySlots on DeliverySlots {
    Matin {
      Pickup {
        Client {
          slotStart
          slotEnd
        }
        WH {
          slotStart
          slotEnd
        }
      }
      Delivery {
        Receiver {
          slotStart
          slotEnd
        }
        WH {
          slotStart
          slotEnd
        }
      }
    }
    Soir {
      Pickup {
        Client {
          slotStart
          slotEnd
        }
        WH {
          slotStart
          slotEnd
        }
      }
      Delivery {
        Receiver {
          slotStart
          slotEnd
        }
        WH {
          slotStart
          slotEnd
        }
      }
    }
    AllDay {
      slotStart
      slotEnd
    }
  }
`;
